import { Helmet } from "react-helmet-async"

import ProductsHero from "../components/Products/ProductsHero"
import HraContact from "../components/Hra/HraContact"

import guideGchra from "../assets/guide-gchra.svg"

export default function Gchra() {
	const schema = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": "Best GCHRA | Simple & Affordable | Salusion",
		"description": "Salusion makes GCHRA administration easy—affordable, IRS-compliant, and hassle-free. Offer tax-free health benefits today!",
		"brand": {
			"@type": "Brand",
			"name": "Salusion"
		},
		"offers": [{
			"@type": "Offer",
			"price": "5.00 / participant / month",
			"priceCurrency": "USD",
			"availability": "https://schema.org/InStock",
			"priceSpecification": {
				"@type": "UnitPriceSpecification",
				"price": "5.00",
				"priceCurrency": "USD",
				"billingDuration": 1,
				"billingIncrement": 1,
				"unitCode": "MON",
				"unitText": "participant/month",
			},
			"eligibleQuantity": {
				"@type": "QuantitativeValue",
				"value": 1,
				"unitText": "participant",
			},
		}],
		"image": "https://salusion.com/assets/images/homepage/reimbursement.svg",
		"url": "https://salusion.com/product/gchra",
	}
	return (
		<>
			<Helmet>
				<title>Best GCHRA | Simple & Affordable | Salusion</title>
				<meta name="title" content="Best GCHRA | Simple & Affordable | Salusion" />
				<meta name="description" content="Salusion makes GCHRA administration easy—affordable, IRS-compliant, and hassle-free. Offer tax-free health benefits today!" />
				<meta name="keywords" content="GCHRA, tax-free benefit, simple HRA administration" />
				<link rel="canonical" href="https://salusion.com/product/gchra" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="Simple & Affordable GCHRA | Salusion" />
				<meta name="twitter:description" content="Stop worrying about health benefits! Salusion makes GCHRA admin easy, IRS-compliant, and affordable. Starting at $5/participant/month." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/homepage/reimbursement.svg" />
				<meta name="twitter:image:alt" content="Illustration of a hand offering money to another hand, representing health reimbursement arrangement." />

				<meta property="og:title" content="Best GCHRA | Simple & Affordable | Salusion" />
				<meta property="og:description" content="Salusion makes GCHRA administration easy—affordable, IRS-compliant, and hassle-free. Offer tax-free health benefits today!" />
				<meta property="og:image" content="https://salusion.com/assets/images/homepage/reimbursement.svg" />
				<meta property="og:url" content="https://salusion.com/product/gchra" />
				<meta property="og:type" content="product" />
				<meta property="og:site_name" content="Salusion" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>
			<ProductsHero
				title="Simple and Affordable GCHRA Administration"
				subtitle="Salusion’s GCHRA administration software makes it easy for employers to help employees cover out-of-pocket expenses not fully paid by their group health plan."
				poster={guideGchra}
				video="https://www.youtube.com/embed/dNix0isqGfw?si=zO81hNyHZGOkrluN"
			/>
			<div className="hra-padding-top">
				<HraContact />
			</div>
		</>
	)
}
